import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import palette from 'constants/palette'
import { buildTranslate } from 'locales'
import React from 'react'
import type { LocationMenu } from '../mockLocationDetails'

const t = buildTranslate('locations.location_list')

type Props = {
  title: string
  description: string
  menus: LocationMenu[]
}

const MenuList = ({ title, description, menus }: Props) => {
  const [css] = useStyletron()
  if (menus.length === 0) return null
  return (
    <section className="mb-xl">
      <Text.Header4 className={`mb-xs ${css({ color: palette.grey90 })}`}>
        {title}
      </Text.Header4>
      <p className={`body-text-3 mb-m ${css({ color: palette.grey70 })}`}>
        {description}
      </p>
      <table className="full-width">
        <thead>
          <tr>
            <th
              className={`bold body-text-4 ${css({
                color: palette.grey90,
                padding: '14px 24px',
                textAlign: 'left',
              })}`}
            >
              {t('location_detail.menu_column')}
            </th>
          </tr>
        </thead>
        <tbody>
          {menus.map(menu => (
            <tr key={menu.id}>
              <td
                className={`body-text-4 ${css({
                  color: palette.grey70,
                  padding: '22px 24px',
                  borderBottom: `1px solid ${palette.grey30}`,
                })}`}
              >
                {menu.name}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  )
}

export default MenuList
